import React from 'react';
import Layout from '../../components/Layout';

const AdminSeasonalPlanning = () => {
  return (
    <Layout>
      <div>
        <h1 style={{ fontSize: '2rem', fontWeight: 'bold', color: '#2e7d32', marginBottom: '2rem' }}>
          Seasonal Planning
        </h1>
        <div className="card">
          <p>Seasonal planning tools coming soon...</p>
        </div>
      </div>
    </Layout>
  );
};

export default AdminSeasonalPlanning;